import { useContext } from "react";
import { selectedTeamCtx } from "../contexts/selectedTeam";

export const useSelectedTeam = () => {
  const context = useContext(selectedTeamCtx);
  if (!context) {
    throw new Error("useSelectedTeam must be used within a SelectedTeamProvider");
  }
  return context;
};
